import ProjectItem from './ProjectItem';

function ProjectList({prjList, getMediaList}) {
  return (
    <ul>
      {
        prjList.map(
          (item, index) => (
            <ProjectItem 
              eachPrj={item} 
              index={index}  
              key={index} 
              getMediaList={getMediaList}
            />
          ))
      }
    </ul>
  );
}

export default ProjectList;